import type { Dimension } from "../../../../types";
import { ButtonSize } from "../types";

export default function getPaddingStyleProps(size: ButtonSize) {
  return size === "standard"
    ? {
        paddingX: "24" as Dimension,
        paddingY: "12" as Dimension
      }
    : {
        paddingX: "xlarge" as Dimension,
        paddingY: "small" as Dimension
      };
}
